import { StyleSheet } from 'aphrodite/no-important';
import { IGenericObject } from 'models/base';
import { children, media } from 'util/style-helpers';
import { SpeakerType } from './Speaker';

export const style: any = (options?: IGenericObject) => {
  return StyleSheet.create({
    flexContainer: {
      width: '50%',
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      maxWidth: 124,
      boxSizing: 'content-box',
      textAlign: 'left',
      marginBottom: 32,

      [media.mobile]: {
        minWidth: 124,
      },

      [media.tablet]: {
        minWidth: 222,
        marginBottom: 45,
      },

      [media.desktop]: {
        minWidth: 290,
        marginBottom: 85,
      },
    },

    image: {
      marginBottom: 10,

      width: 124,

      [media.mobile]: {
        minWidth: 124,
      },

      [media.tablet]: {
        width: 222,
      },

      [media.desktop]: {
        width: 290,
      },
    },

    title: {
      fontWeight: 500,
      fontSize: options?.type === SpeakerType.PRIMARY ? 16 : 14,
      lineHeight: 1.36,
      marginBottom: 5,

      [media.tablet]: {
        fontSize: options?.type === SpeakerType.PRIMARY ? 25 : 20,
        lineHeight: '25px',
        marginBottom: 10,
      },
    },

    subtitle: {
      fontSize: options?.type === SpeakerType.PRIMARY ? 14 : 11,
      color: '#C1C0C0',

      [media.tablet]: {
        fontSize: options?.type === SpeakerType.PRIMARY ? 25 : 16,
      },
    },

    [SpeakerType.PRIMARY]: {
      alignItems: 'center',
      width: '100%',
      maxWidth: 'initial',
      marginBottom: '42px',

      [children('img')]: {
        width: '280px',
        heigh: 'auto',

        [media.tablet]: {
          width: '570px',
        },
      },
      [children('span')]: {
        width: '280px',

        [media.tablet]: {
          width: '570px',
        },
      },
    },
    [SpeakerType.SECONDARY]: {
      alignItems: 'center',
      width: '100%',
      maxWidth: 'initial',
      marginBottom: '42px',

      [children('img')]: {
        width: '124px',
        heigh: 'auto',

        [media.tablet]: {
          width: '222px',
        },

        [media.desktop]: {
          width: '290px',
        },
      },
      [children('span')]: {
        width: '124px',

        [media.tablet]: {
          width: '222px',
        },

        [media.desktop]: {
          width: '290px',
        },
      },
    },
    [SpeakerType.DEFAULT]: {},
  });
};
